export default "__VITE_ASSET__D_F3JOlB__"